/* istanbul ignore file */
export * from './LegalHintsCard';
